import * as React from 'react'

import { Field, FieldDataValue } from 'embed/constants'

const styles = require('./styles')

export interface Props {
  field: Field
  value?: FieldDataValue
}

const ReadOnlyField = ({ field, value }: Props) => (
  <div className={styles.field}>
    <label className={styles.label}>{field.options.label}</label>
    <div className={styles.value}>{value} </div>
  </div>
)

export default ReadOnlyField
